<div class="modal-content">
    <div class="modal-header" *ngIf="option.title">{{ option.title }}</div>
    <div class="modal-body">
        <input class="form-control" [placeholder]="option.placeholder" name="text" *ngIf="!option.type || option.type === ''"
            [(ngModel)]="option.value" appFocus
        >
        <app-datepicker format="YYYY-MM-DD HH:mm" showTime="true" [maxNow]=true name="text" *ngIf="option.type === 'date'"
            [(ngModel)]="option.value" appFocus>
        </app-datepicker>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" [disabled]="!valid()" (click)="done($event)">OK</button>
        <button type="button" class="btn btn-secondary" (click)="bsModalRef.hide()">Cancelar</button>
    </div>
</div>
